<script lang="ts" setup>
import { digitsEnToFa } from "@persian-tools/persian-tools"
import moment from "jalali-moment"

defineProps<{
	data: {
		title?: string
		slug: string
		createdAt?: string | any
		image?: {
			url: string
		}
		category?: {
			name: string
		}
		writer?: {
			name: string
			image?: {
				url: string
			}
		}
	}[]
}>()

const config = useRuntimeConfig()
</script>

<template>
	<section
		class="py-12">
		<div class="flex flex-col items-center justify-center container">
			<LandingTitle class="mb-12">
				<template #title>
					وبلاگ
				</template>

				<template #description>
					آخرین پست های توکا رو اینجا ببین.
				</template>
			</LandingTitle>

			<div
				data-aos="fade-up"
				class="grid max-w-1100px w-full gap-5 overflow-x-auto grid-fit-350px">
				<BlogCard
					v-for="item in data"
					:key="item.slug"
					:slug="item.slug"
					:writer="item.writer?.name"
					:category="item.category?.name"
					:profile-pic="`${config.public.strapi.address}${item.writer?.image?.url}`"
					:date="digitsEnToFa(moment(item.createdAt).locale('fa').format('jD jMMM jYYYY')) || ''"
					:image-src="`${config.public.strapi.address}${item.image?.url}`"
					:title="item.title" />
			</div>

			<NuxtLink
				href="/blogs"
				class="mt-8">
				<Btn class="h-8 w-fit flex gap-2 border-2 border-foreground rounded-md border-solid text-sm">
					<Icon
						name="i-solar:arrow-down-outline"
						class="size-[17px]" />
					مطالعه بیشتر
				</Btn>
			</NuxtLink>
		</div>
	</section>
</template>
